import { cn } from '@utils/cn';
import { PropsWithChildren } from 'react';

export const Card = ({
  children,
  className,
}: PropsWithChildren<{
  className?: string;
}>) => {
  return (
    <div
      className={cn(
        'relative w-full overflow-hidden rounded-sm ring-1 ring-divider/20',
        className,
      )}
    >
      {children}
    </div>
  );
};
